import { useAuth } from "@/src/contexts/auth.context";
import {
  useGetCurrentActiveSeason,
  useGetStarTransactionsInfinite,
} from "@/src/services/api/rewardly/rewardly.hooks";
import { useTheme } from "@/src/styles/theme-provider";
import { FavoriteChart } from "iconsax-react-nativejs";
import { useTranslation } from "react-i18next";
import { ActivityIndicator, Pressable, Text, View } from "react-native";
import TransactionCard from "./transaction-card";

const RecentActivity = () => {
  const { t } = useTranslation();
  const { themeVars } = useTheme();
  const { user, orgId } = useAuth();
  const { data: seasonData } = useGetCurrentActiveSeason(orgId ?? "");
  const currentSeason = seasonData?.getseasons?.items?.[0];

  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useGetStarTransactionsInfinite(currentSeason?.ItemId ?? "");

  const allTransactions = data?.pages.flatMap(
    page => page?.getstarTransactions?.items ?? []
  ) ?? [];

  const myTransactions = allTransactions.filter(
    t => t.recipientId === user?.itemId
  );

  return (
    <View className="flex-col min-h-[320px] md:min-h-0 md:flex-1 md:border md:border-ash-3 bg-chalk rounded-xl p-4 md:p-5">
      <View className="flex-row items-center gap-2 mb-4">
        <FavoriteChart size={28} color={themeVars["--color-primary-default"] as string} />
        <Text className="text-lg md:text-xl font-semibold text-onyx flex-1">
          {t("LABEL_RECENT_ACTIVITY")}
        </Text>
      </View>

      {isLoading ? (
        <View className="flex-1 items-center justify-center py-8">
          <ActivityIndicator />
        </View>
      ) : myTransactions.length === 0 ? (
        <View className="flex-1 items-center justify-center py-8">
          <Text className="text-ash-2">{t("LABEL_NO_ACTIVITY_YET")}</Text>
        </View>
      ) : (
        // Plain list (not FlatList): this panel lives inside the page's
        // ScrollView, and nesting a same-orientation VirtualizedList throws.
        <View className="gap-2">
          {myTransactions.map((item) => (
            <TransactionCard key={item.ItemId} transaction={item} />
          ))}
          {hasNextPage && (
            <Pressable
              onPress={() => fetchNextPage()}
              disabled={isFetchingNextPage}
              className="items-center py-3 active:opacity-70 hover:bg-ash-3 hover:rounded-lg"
            >
              {isFetchingNextPage ? (
                <ActivityIndicator />
              ) : (
                <Text className="text-sm font-medium text-primary">
                  {t("BTN_LOAD_MORE")}
                </Text>
              )}
            </Pressable>
          )}
        </View>
      )}
    </View>
  );
};

export default RecentActivity;
